<template>
  <PropertyOnboardingStep
    :wide="true"
    :is-next-button-disabled="isNextButtonDisabled"
    :full-width="true"
    :submit="submit"
  >
    <PropertyImagesEdit
      title="Add your property photos"
      :is-visible-upload-button="false"
      :variant="'minimal'"
      ref="propertyImagesEditRef"
    />

    <Hint class="hint" icon="bulb">
      <div>These should be the pictures that showcase the best parts of your listing</div>
      <Link
        class="hint-link"
        color="accent"
        to="https://www.mynd.co/knowledge-center/advertising-your-rental-property"
        target="_blank"
      >
        How to take nice photos
      </Link>
    </Hint>
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Link, Hint } from '@tallo/design-system';
import { PropertyImagesEdit, usePropertyImagesStore } from '@tallo/investor/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const imagesStore = usePropertyImagesStore();
const propertyImagesEditRef = ref<InstanceType<typeof PropertyImagesEdit>>();
const isNextButtonDisabled = computed(() => propertyImagesEditRef.value?.isUploading);

async function submit() {
  await imagesStore.updateImagesOrder();
}
</script>

<style scoped lang="scss">
.hint {
  margin-top: var(--t-spacing-md);
}

.hint-link {
  display: inline-block;
  margin-top: var(--t-spacing-sm);
}
</style>
